import { useDispatch } from 'react-redux';
import { useFlag } from '@/features/unleash';
import NotFound from '@/pages/NotFound';
import useNarrative from '@/pages/Narrative/hooks/useNarrative';
import { Form } from '@/components/NarrativeForm';
import {
  CreateNarrativeRequest,
  UpdateNarrativeRequest,
} from '@/components/NarrativeForm/types';
import { useUpdateNarrative } from '../../hooks/useUpdateNarrative';
import { ROUTE_NARRATIVE_LIST } from '@/constants/routes';
import useUser from '@/hooks/useUser';
import DocumentHeader from '@/components/DocumentHeader';

export const EditNarrative = () => {
  const dispatch = useDispatch();
  const { data: user } = useUser();
  const flag = useFlag({ name: 'mono-narrative-authoring' });
  const { data } = useNarrative();

  const { mutate: updateNarrative, status } = useUpdateNarrative({
    narrativeSlug: data.slug,
    onSuccess: () => {
      setTimeout(() => {
        dispatch({
          type: ROUTE_NARRATIVE_LIST,
        });
      }, 2500);
    },
  });

  if (!user.loggedIn || !data.id || !flag.flagsReady || !flag.enabled) {
    return <NotFound />;
  }

  const keyTakeaways = {
    contentHtml: data.keyTakeaways || '',
    title: 'Key Takeaways',
  };

  const fields: CreateNarrativeRequest = {
    title: data.title,
    authorId: data.author.id,
    status: data.status as CreateNarrativeRequest['status'],
    visibility: data.visibility as CreateNarrativeRequest['visibility'],
    companyId: data.companyId,
    currencyIso: data.currencyIso,
    valuations: data.valuations,
    contentBlocks: [keyTakeaways, ...data.contentBlocks],
    publishDate: new Date(data.publishedAt).toISOString(),
    coverImageUrl: data.coverImageUrl,
    userHoldsPosition: data.userHoldsPosition,
    disclaimer: data.disclaimer,
    companyCanonicalUrl: data.companyCanonicalUrl,
  };

  const submit = (params: CreateNarrativeRequest) => {
    const updatedParams: UpdateNarrativeRequest = Object.assign(fields, {
      ...params,
      companyId: data.companyId,
      id: data.id,
    });
    updateNarrative(updatedParams);
  };

  return (
    <>
      <DocumentHeader title="Edit Narrative" />
      <Form
        onSubmit={(params: CreateNarrativeRequest) => submit(params)}
        status={status}
        narrative={fields}
      />
    </>
  );
};
